/**
 * @desc coupon store
 */

import actions from '../actions/couponAction'
import getters from '../getters/couponGetters'
import mutations from '../mutations/couponMutation'

const state = {
  // 优惠券列表
  couponList: {
    count: 0,
    usableList: [],
    unusableList: []
  },
  // 商品可领取优惠券
  productAvaliableCouponList: {
    receiveList: [] // 当前商品用户未领取优惠券
    , receiveErrorLength: 0 // 领取失败条数
    , receiveSuccessLength: 0 // 领取成功条数
  },
  // 订单提交的优惠券信息
  couponInfo: {}
}

export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
